import { useNavigate } from 'react-router-dom';

export function useSafeNavigateBack(fallbackPath) {
  const navigate = useNavigate();
  return () => {
    const canGoBack = window.history.state && window.history.state.idx > 0;

    canGoBack ? navigate(-1) : navigate(fallbackPath);
  };
}
